/**
 * i18n key for the message shown when a write hits an HTTP 409 Conflict. Shared
 * by `useMutationErrorSnackbar` and by the checkout flow's rethrowing catches so
 * the wording stays in sync. With `keySeparator: false`, the key is the English
 * sentence itself.
 * @type {string}
 */
export const CONFLICT_REFRESH_MESSAGE = 'Someone else updated this order. Please refresh the page and try again.'

/**
 * True when an RTK Query error represents an HTTP 409 Conflict, raised by the
 * backend's optimistic-concurrency (row-version) checks.
 *
 * `fetchBaseQuery` rejects an unwrapped mutation with `{ status, data }`, where
 * `status` is the numeric HTTP status code.
 * @param {unknown} error - The error caught from a rejected `.unwrap()` call.
 * @returns {boolean} `true` only when `error.status` is the number `409`.
 */
export const isConflictError = (error) => error?.status === 409
